import { useEffect, useMemo, useState } from "react"
import { InterestResult, useListInterest } from "interface/author/interest"

type useInterestProps = {
	searchId: number | undefined
	authorId: number | undefined
}
export const useInterest = ({
	searchId,
	authorId
}: useInterestProps) => {
	const [editInterest, setEditInterest] = useState<{ action: 'create' | 'edit', data: InterestResult | null } | null>(null)
	const [interestList, setInterestList] = useState<InterestResult[]>([])
	const interestListState = useListInterest(searchId, authorId)

	useEffect(
		() => {
			if (interestListState.loading) return
			const interestList = interestListState.data?.list
				.filter(interest => {
					if (interest.confidenceScore !== null && interest.confidenceScore <= 1) return false
					if (interest.title === '推定不能' || interest.title === '提案不能') return false
					return true
				}) ?? []
			setInterestList(interestList)
		},
		[interestListState]
	)
	return useMemo(() => ({
		searchId,
		authorId,
		loading: interestListState.loading,
		error: interestListState.error,
		editInterest, setEditInterest,
		interestList, setInterestList
	}), [
		searchId,
		authorId,
		editInterest, setEditInterest,
		interestList, setInterestList,
		interestListState
	])
}
